require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-lessons-from-covid-19-can-the-world-bank-apply.json") })
        }
      }, "path---en-us-update-what-lessons-from-covid-19-can-the-world-bank-apply");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-lessons-from-covid-19-can-the-world-bank-apply!./.cache/json/en-us-update-what-lessons-from-covid-19-can-the-world-bank-apply.json
// module id = 847
// module chunks = 231608221292675